<template>
  <div v-loading="listContentLoading">
    <el-input
      class="search-el"
      size="mini"
      v-model="query.name"
      clearable
      placeholder="请输入名称"
    ></el-input>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加</el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="3%"
        ></el-table-column>
        <el-table-column label="名称" align="center" min-width="25%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="update(row)">
              <div>{{ row.name }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 在线</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未启用</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "禁用" : "启用" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="添加小程序"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="addEditFormOnClose"
      width="50%"
    >
      <el-form :model="info" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称" required>
          <el-input
            v-model="info.name"
            show-word-limit
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="APP ID" required>
          <el-input
            v-model="info.app_id"
            show-word-limit
            placeholder="请输入APP ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="APP Secret" required>
          <el-input
            v-model="info.secret"
            show-word-limit
            placeholder="请输入APP Secret"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="createUpdate()"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  updateStatus,
  del,
  createUpdate,
} from "@/api/tool/miniprogram";

export default {
  data: function () {
    return {
      dialogVisible: false,
      updateLoading: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: "",
      },

      listContentLoading: false,

      info: {
        id: 0,
        name: "",
        app_id: "",
        secret: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    addEditFormOnClose() {
      this.info.id = 0;
      this.info.name = this.info.app_id = this.info.secret = '';
    },

    toCreate() {
      this.$confirm("请确认小程序已配置完成，并上架成功, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.dialogVisible = true;
      });
    },

    update(row) {
      this.dialogVisible = true;
      this.info.id = row.id;
      this.info.name = row.name;
      this.info.app_id = row.app_id;
      this.info.secret = row.secret;
    },

    createUpdate() {
      this.updateLoading = true;
      createUpdate(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.dialogVisible = false;
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
